import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class InventoryData_PurchaseGuide {
  get descriptor() {
    return InventoryData_PurchaseGuide.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasNavigation = false;
    this._navigation = null;
  }
  isEmpty() {
    if (this._hasNavigation && !this._navigation.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InventoryData_PurchaseGuide) {
      return value;
    }
    return InventoryData_PurchaseGuide.fromJson(value);
  }
  static fromJson(json) {
    const result = new InventoryData_PurchaseGuide();
    if (json.navigation != null) {
      result._hasNavigation = true;
      result._navigation = dcei_wildsky_common_proto.PageNavigationEntry.fromJson(json.navigation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasNavigation && !this._navigation.isEmpty()) {
      result.navigation = dcei_wildsky_common_proto.PageNavigationEntry.toJson(this._navigation);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.PageNavigationEntry}
   */
  get navigation() {
    return this._hasNavigation ? this._navigation : dcei_wildsky_common_proto.PageNavigationEntry.default;
  }
  get hasNavigation() {
    return this._hasNavigation;
  }
  setNavigation(path, value) {
    return {type: 'SET', path: path.concat(['navigation']), value: value.toJson()};
  }
  deleteNavigation(path) {
    return {type: 'DELETE', path: path.concat(['navigation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "navigation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_PurchaseGuide(this);
              copy._hasNavigation = true;
              copy._navigation = dcei_wildsky_common_proto.PageNavigationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNavigation) {
                return this;
              }
              const copy = new InventoryData_PurchaseGuide(this);
              copy._hasNavigation = false;
              copy._navigation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasNavigation) {
            const copy = new InventoryData_PurchaseGuide(this);
            copy._hasNavigation = true;
            copy._navigation = dcei_wildsky_common_proto.PageNavigationEntry.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._navigation.apply(type, path.slice(1), value);
          if (newValue === this._navigation) {
            return this;
          }
          const copy = new InventoryData_PurchaseGuide(this);
          copy._navigation = copy._navigation.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InventoryData_PurchaseGuide} other
   * @returns {InventoryData_PurchaseGuide}
   */
  merge(other) {
    const copy = new InventoryData_PurchaseGuide(this);
    if (other._hasNavigation) {
      if (copy._hasNavigation) {
        copy._navigation = copy.navigation.merge(other.navigation);
      } else {
        copy._navigation = other._navigation;
      }
      copy._hasNavigation = true;
    }
    return copy;
  }
}
InventoryData_PurchaseGuide.default = new InventoryData_PurchaseGuide();
class InventoryData_PurchaseGuide_Builder {
  constructor(value) {
    this._value = new InventoryData_PurchaseGuide(value);
  }
  build() {
    return new InventoryData_PurchaseGuide(this._value);
  }
  setNavigation(value) {
    this._value._hasNavigation = true;
    this._value._navigation = value;
    return this;
  }
  deleteNavigation() {
    this._value._hasNavigation = false;
    this._value._navigation = null;
    return this;
  }
}
InventoryData_PurchaseGuide.Builder = InventoryData_PurchaseGuide_Builder;
class InventoryData_PurchaseGuide_WithParent {
  /**
   * @param {InventoryData_PurchaseGuide} value
   * @param {InventoryData_PurchaseGuide_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InventoryData_PurchaseGuide.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasNavigation() {
    if (this._cachedHasNavigation === undefined) {
      if (this._value.hasNavigation) {
        this._cachedHasNavigation = true;
      } else {
        this._cachedHasNavigation = this._parent ? this._parent.hasNavigation : false;
      }
    }
    return this._cachedHasNavigation;
  }
  get navigation() {
    if (!this._cachedNavigation) {
      if (this._value.hasNavigation) {
        this._cachedNavigation = new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(this._value.navigation, this._parent && this._parent.hasNavigation ? this._parent.navigation : null);
      } else {
        this._cachedNavigation = this._parent ? new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(dcei_wildsky_common_proto.PageNavigationEntry.default, this._parent.navigation) : dcei_wildsky_common_proto.PageNavigationEntry.WithParent.default;
      }
    }
    return this._cachedNavigation;
  }
  update(current, parent) {
    const result = new InventoryData_PurchaseGuide_WithParent(current, parent);
    if (this._cachedNavigation && this._value.hasNavigation && current.hasNavigation) {
      if (this._value.navigation === current.navigation && this._parent === parent) {
        result._cachedNavigation = this._cachedNavigation;
      } else {
        result._cachedNavigation = this._cachedNavigation.update(current.navigation, parent && parent.hasNavigation ? parent.navigation : null);
      }
    }
    return result;
  }
}
InventoryData_PurchaseGuide_WithParent.default = new InventoryData_PurchaseGuide_WithParent(InventoryData_PurchaseGuide.default, null);
InventoryData_PurchaseGuide.WithParent = InventoryData_PurchaseGuide_WithParent;
class InventoryData_PurchaseGuide_Descriptor {
  get navigation() {
    if (!this._navigation) {
      this._navigation = {
        name: "navigation",
        Name: "Navigation",
        number: 1,
        protoType: 11,
        protoName: "navigation",
        type: dcei_wildsky_common_proto.PageNavigationEntry,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navigation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.navigation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForNavigation",
        Name: "DummyOneofForNavigation",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
InventoryData_PurchaseGuide.descriptor = new InventoryData_PurchaseGuide_Descriptor();
class InventoryData_Item {
  get descriptor() {
    return InventoryData_Item.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasIcon = false;
    this._icon = null;
    this._hasDescription = false;
    this._description = null;
    this._hasStar = false;
    this._star = null;
    this._hasHideInInventory = false;
    this._hideInInventory = null;
    this._navigationEntries = [];
    this._hasPurchaseGuide = false;
    this._purchaseGuide = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDisplayName) return false;
    if (this._hasIcon) return false;
    if (this._hasDescription) return false;
    if (this._hasStar) return false;
    if (this._hasHideInInventory) return false;
    if (this._navigationEntries.length > 0) return false;
    if (this._hasPurchaseGuide && !this._purchaseGuide.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InventoryData_Item) {
      return value;
    }
    return InventoryData_Item.fromJson(value);
  }
  static fromJson(json) {
    const result = new InventoryData_Item();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.icon != null) {
      result._hasIcon = true;
      result._icon = JsonToString.fromJson(json.icon);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.star != null) {
      result._hasStar = true;
      result._star = JsonToInt32.fromJson(json.star);
    }
    if (json.hideInInventory != null) {
      result._hasHideInInventory = true;
      result._hideInInventory = JsonToBoolean.fromJson(json.hideInInventory);
    }
    result._navigationEntries = JsonToList(json.navigationEntries, dcei_wildsky_common_proto.PageNavigationEntry);
    if (json.purchaseGuide != null) {
      result._hasPurchaseGuide = true;
      result._purchaseGuide = InventoryData_PurchaseGuide.fromJson(json.purchaseGuide);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasIcon) {
      result.icon = JsonToString.toJson(this._icon);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasStar) {
      result.star = JsonToInt32.toJson(this._star);
    }
    if (this._hasHideInInventory) {
      result.hideInInventory = JsonToBoolean.toJson(this._hideInInventory);
    }
    if (this._navigationEntries.length > 0) {
      result.navigationEntries = ArrayToJson(this._navigationEntries, dcei_wildsky_common_proto.PageNavigationEntry);
    }
    if (this._hasPurchaseGuide && !this._purchaseGuide.isEmpty()) {
      result.purchaseGuide = InventoryData_PurchaseGuide.toJson(this._purchaseGuide);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string}
   */
  get icon() {
    return this._hasIcon ? this._icon : JsonToString.default;
  }
  get hasIcon() {
    return this._hasIcon;
  }
  setIcon(path, value) {
    return {type: 'SET', path: path.concat(['icon']), value};
  }
  deleteIcon(path) {
    return {type: 'DELETE', path: path.concat(['icon'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {number}
   */
  get star() {
    return this._hasStar ? this._star : JsonToInt32.default;
  }
  get hasStar() {
    return this._hasStar;
  }
  setStar(path, value) {
    return {type: 'SET', path: path.concat(['star']), value};
  }
  deleteStar(path) {
    return {type: 'DELETE', path: path.concat(['star'])};
  }
  /**
   * @returns {boolean}
   */
  get hideInInventory() {
    return this._hasHideInInventory ? this._hideInInventory : JsonToBoolean.default;
  }
  get hasHideInInventory() {
    return this._hasHideInInventory;
  }
  setHideInInventory(path, value) {
    return {type: 'SET', path: path.concat(['hideInInventory']), value};
  }
  deleteHideInInventory(path) {
    return {type: 'DELETE', path: path.concat(['hideInInventory'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.PageNavigationEntry[]}
   */
  get navigationEntries() {
    return this._navigationEntries;
  }
  addNavigationEntries(path, value) {
    return {type: 'ADD', path: path.concat(['navigationEntries']), value: value.toJson()};
  }
  setNavigationEntries(path, value) {
    return {type: 'SET', path: path.concat(['navigationEntries']), value: ArrayToJson(value, dcei_wildsky_common_proto.PageNavigationEntry)};
  }
  setNavigationEntriesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['navigationEntries', key]), value: value.toJson()};
  }
  deleteNavigationEntries(path) {
    return {type: 'DELETE', path: path.concat(['navigationEntries'])};
  }
  deleteNavigationEntriesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['navigationEntries', key])};
  }
  /**
   * @returns {InventoryData_PurchaseGuide}
   */
  get purchaseGuide() {
    return this._hasPurchaseGuide ? this._purchaseGuide : InventoryData_PurchaseGuide.default;
  }
  get hasPurchaseGuide() {
    return this._hasPurchaseGuide;
  }
  setPurchaseGuide(path, value) {
    return {type: 'SET', path: path.concat(['purchaseGuide']), value: value.toJson()};
  }
  deletePurchaseGuide(path) {
    return {type: 'DELETE', path: path.concat(['purchaseGuide'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new InventoryData_Item(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new InventoryData_Item(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "icon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._hasIcon = true;
              copy._icon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIcon) {
                return this;
              }
              const copy = new InventoryData_Item(this);
              copy._hasIcon = false;
              copy._icon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new InventoryData_Item(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "star": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._hasStar = true;
              copy._star = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar) {
                return this;
              }
              const copy = new InventoryData_Item(this);
              copy._hasStar = false;
              copy._star = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hideInInventory": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._hasHideInInventory = true;
              copy._hideInInventory = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHideInInventory) {
                return this;
              }
              const copy = new InventoryData_Item(this);
              copy._hasHideInInventory = false;
              copy._hideInInventory = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "navigationEntries": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._navigationEntries = [];        for (let i of value) {
                copy._navigationEntries.push(dcei_wildsky_common_proto.PageNavigationEntry.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InventoryData_Item(this);
              copy._navigationEntries = copy._navigationEntries.concat([dcei_wildsky_common_proto.PageNavigationEntry.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._navigationEntries.length === 0) {
                return this;
              }
              const copy = new InventoryData_Item(this);
              copy._navigationEntries = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._navigationEntries.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._navigationEntries = copy._navigationEntries.slice();
              copy._navigationEntries[path[1]] = dcei_wildsky_common_proto.PageNavigationEntry.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InventoryData_Item(this);
              copy._navigationEntries = copy._navigationEntries.slice(0, path[1]).concat(copy._navigationEntries.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._navigationEntries.length) {
            return this;
          }
          const oldValue = this._navigationEntries[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InventoryData_Item(this);
          copy._navigationEntries = copy._navigationEntries.slice();
          copy._navigationEntries[key] = newValue;
          return copy;
        }
      }
      case "purchaseGuide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_Item(this);
              copy._hasPurchaseGuide = true;
              copy._purchaseGuide = InventoryData_PurchaseGuide.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseGuide) {
                return this;
              }
              const copy = new InventoryData_Item(this);
              copy._hasPurchaseGuide = false;
              copy._purchaseGuide = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPurchaseGuide) {
            const copy = new InventoryData_Item(this);
            copy._hasPurchaseGuide = true;
            copy._purchaseGuide = InventoryData_PurchaseGuide.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._purchaseGuide.apply(type, path.slice(1), value);
          if (newValue === this._purchaseGuide) {
            return this;
          }
          const copy = new InventoryData_Item(this);
          copy._purchaseGuide = copy._purchaseGuide.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InventoryData_Item} other
   * @returns {InventoryData_Item}
   */
  merge(other) {
    const copy = new InventoryData_Item(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasIcon) {
      copy._hasIcon = true;
      copy._icon = other._icon;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasStar) {
      copy._hasStar = true;
      copy._star = other._star;
    }
    if (other._hasHideInInventory) {
      copy._hasHideInInventory = true;
      copy._hideInInventory = other._hideInInventory;
    }
    copy._navigationEntries = this._navigationEntries.concat(other._navigationEntries);
    if (other._hasPurchaseGuide) {
      if (copy._hasPurchaseGuide) {
        copy._purchaseGuide = copy.purchaseGuide.merge(other.purchaseGuide);
      } else {
        copy._purchaseGuide = other._purchaseGuide;
      }
      copy._hasPurchaseGuide = true;
    }
    return copy;
  }
}
InventoryData_Item.default = new InventoryData_Item();
class InventoryData_Item_Builder {
  constructor(value) {
    this._value = new InventoryData_Item(value);
  }
  build() {
    return new InventoryData_Item(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setIcon(value) {
    this._value._hasIcon = true;
    this._value._icon = value;
    return this;
  }
  deleteIcon() {
    this._value._hasIcon = false;
    this._value._icon = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setStar(value) {
    this._value._hasStar = true;
    this._value._star = value;
    return this;
  }
  deleteStar() {
    this._value._hasStar = false;
    this._value._star = null;
    return this;
  }
  setHideInInventory(value) {
    this._value._hasHideInInventory = true;
    this._value._hideInInventory = value;
    return this;
  }
  deleteHideInInventory() {
    this._value._hasHideInInventory = false;
    this._value._hideInInventory = null;
    return this;
  }
  addAllNavigationEntries(values) {
    this._value._navigationEntries = this._value._navigationEntries.concat(values);
    return this;
  }
  addNavigationEntries(value) {
    this._value._navigationEntries = this._value._navigationEntries.concat([value]);
    return this;
  }
  setNavigationEntries(index, value) {
    this._value._navigationEntries = this._value._navigationEntries.concat();
    this._value._navigationEntries[index] = value;
    return this;
  }
  clearNavigationEntries() {
    this._value._navigationEntries = [];
    return this;
  }
  setPurchaseGuide(value) {
    this._value._hasPurchaseGuide = true;
    this._value._purchaseGuide = value;
    return this;
  }
  deletePurchaseGuide() {
    this._value._hasPurchaseGuide = false;
    this._value._purchaseGuide = null;
    return this;
  }
}
InventoryData_Item.Builder = InventoryData_Item_Builder;
class InventoryData_Item_WithParent {
  /**
   * @param {InventoryData_Item} value
   * @param {InventoryData_Item_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InventoryData_Item.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasIcon() {
    if (this._cachedHasIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedHasIcon = true;
      } else {
        this._cachedHasIcon = this._parent ? this._parent.hasIcon : false;
      }
    }
    return this._cachedHasIcon;
  }
  get icon() {
    if (this._cachedIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedIcon = this._value.icon;
      } else {
        this._cachedIcon = this._parent ? this._parent.icon : this._value.icon;
      }
    }
    return this._cachedIcon;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasStar() {
    if (this._cachedHasStar === undefined) {
      if (this._value.hasStar) {
        this._cachedHasStar = true;
      } else {
        this._cachedHasStar = this._parent ? this._parent.hasStar : false;
      }
    }
    return this._cachedHasStar;
  }
  get star() {
    if (this._cachedStar === undefined) {
      if (this._value.hasStar) {
        this._cachedStar = this._value.star;
      } else {
        this._cachedStar = this._parent ? this._parent.star : this._value.star;
      }
    }
    return this._cachedStar;
  }
  get hasHideInInventory() {
    if (this._cachedHasHideInInventory === undefined) {
      if (this._value.hasHideInInventory) {
        this._cachedHasHideInInventory = true;
      } else {
        this._cachedHasHideInInventory = this._parent ? this._parent.hasHideInInventory : false;
      }
    }
    return this._cachedHasHideInInventory;
  }
  get hideInInventory() {
    if (this._cachedHideInInventory === undefined) {
      if (this._value.hasHideInInventory) {
        this._cachedHideInInventory = this._value.hideInInventory;
      } else {
        this._cachedHideInInventory = this._parent ? this._parent.hideInInventory : this._value.hideInInventory;
      }
    }
    return this._cachedHideInInventory;
  }
  get selfNavigationEntries() {
    if (!this._selfNavigationEntries) {
      this._selfNavigationEntries = [];
      for (let i of this._value.navigationEntries) {
        this._selfNavigationEntries.push(new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(i, null));
      }
    }
    return this._selfNavigationEntries;
  }
  get inherentNavigationEntries() {
    if (!this._inherentNavigationEntries) {
      this._inherentNavigationEntries = this._parent ? this._parent.navigationEntries : [];
    }
    return this._inherentNavigationEntries;
  }
  get navigationEntries() {
    if (!this._allNavigationEntries) {
      this._allNavigationEntries = this._parent ? this._parent.navigationEntries.concat(this.selfNavigationEntries) : this.selfNavigationEntries;
    }
    return this._allNavigationEntries;
  }
  get hasPurchaseGuide() {
    if (this._cachedHasPurchaseGuide === undefined) {
      if (this._value.hasPurchaseGuide) {
        this._cachedHasPurchaseGuide = true;
      } else {
        this._cachedHasPurchaseGuide = this._parent ? this._parent.hasPurchaseGuide : false;
      }
    }
    return this._cachedHasPurchaseGuide;
  }
  get purchaseGuide() {
    if (!this._cachedPurchaseGuide) {
      if (this._value.hasPurchaseGuide) {
        this._cachedPurchaseGuide = new InventoryData_PurchaseGuide.WithParent(this._value.purchaseGuide, this._parent && this._parent.hasPurchaseGuide ? this._parent.purchaseGuide : null);
      } else {
        this._cachedPurchaseGuide = this._parent ? new InventoryData_PurchaseGuide.WithParent(InventoryData_PurchaseGuide.default, this._parent.purchaseGuide) : InventoryData_PurchaseGuide.WithParent.default;
      }
    }
    return this._cachedPurchaseGuide;
  }
  update(current, parent) {
    const result = new InventoryData_Item_WithParent(current, parent);
    if (this._selfNavigationEntries) {
      if (this._value.navigationEntries === current.navigationEntries) {
        result._selfNavigationEntries = this._selfNavigationEntries;
      } else {
        result._selfNavigationEntries = [];
        for (let i = 0; i < current.navigationEntries.length; i++) {
          const oldValue = this._value.navigationEntries[i];
          if (oldValue) {
            const oldCache = this._selfNavigationEntries[i];
            if (oldValue === current.navigationEntries[i]) {
              result._selfNavigationEntries[i] = oldCache;
            } else {
              result._selfNavigationEntries[i] = oldCache.update(current.navigationEntries[i], null);
            }
          } else {
            result._selfNavigationEntries[i] = new dcei_wildsky_common_proto.PageNavigationEntry.WithParent(current.navigationEntries[i], null);
          }
        }
      }
    }
    if (this._cachedPurchaseGuide && this._value.hasPurchaseGuide && current.hasPurchaseGuide) {
      if (this._value.purchaseGuide === current.purchaseGuide && this._parent === parent) {
        result._cachedPurchaseGuide = this._cachedPurchaseGuide;
      } else {
        result._cachedPurchaseGuide = this._cachedPurchaseGuide.update(current.purchaseGuide, parent && parent.hasPurchaseGuide ? parent.purchaseGuide : null);
      }
    }
    return result;
  }
}
InventoryData_Item_WithParent.default = new InventoryData_Item_WithParent(InventoryData_Item.default, null);
InventoryData_Item.WithParent = InventoryData_Item_WithParent;
class InventoryData_Item_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get icon() {
    if (!this._icon) {
      this._icon = {
        name: "icon",
        Name: "Icon",
        number: 3,
        protoType: 9,
        protoName: "icon",
        type: JsonToString,
        options: {
          valueDropdown: "InventoryItemIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._icon;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 4,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get star() {
    if (!this._star) {
      this._star = {
        name: "star",
        Name: "Star",
        number: 5,
        protoType: 5,
        protoName: "star",
        type: JsonToInt32,
        options: {
          comments: "How many stars to display",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star;
  }
  get hideInInventory() {
    if (!this._hideInInventory) {
      this._hideInInventory = {
        name: "hideInInventory",
        Name: "HideInInventory",
        number: 6,
        protoType: 8,
        protoName: "hide_in_inventory",
        type: JsonToBoolean,
        options: {
          comments: "whether or not to display this item in inventory page",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hideInInventory;
  }
  get navigationEntries() {
    if (!this._navigationEntries) {
      this._navigationEntries = {
        name: "navigationEntries",
        Name: "NavigationEntries",
        number: 7,
        protoType: 11,
        protoName: "navigation_entries",
        type: dcei_wildsky_common_proto.PageNavigationEntry,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._navigationEntries;
  }
  get purchaseGuide() {
    if (!this._purchaseGuide) {
      this._purchaseGuide = {
        name: "purchaseGuide",
        Name: "PurchaseGuide",
        number: 8,
        protoType: 11,
        protoName: "purchase_guide",
        type: InventoryData_PurchaseGuide,
        options: {
          comments: "This is used for a generic solution when an item is not enough, then we lead players to do stuff",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseGuide;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.displayName,
        this.icon,
        this.description,
        this.star,
        this.hideInInventory,
        this.navigationEntries,
        this.purchaseGuide,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIcon",
        Name: "DummyOneofForIcon",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStar",
        Name: "DummyOneofForStar",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHideInInventory",
        Name: "DummyOneofForHideInInventory",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseGuide",
        Name: "DummyOneofForPurchaseGuide",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
InventoryData_Item.descriptor = new InventoryData_Item_Descriptor();
class InventoryData_ItemConversionData {
  get descriptor() {
    return InventoryData_ItemConversionData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasFromItemKey = false;
    this._fromItemKey = null;
    this._hasFromItemAmount = false;
    this._fromItemAmount = null;
    this._hasToItemKey = false;
    this._toItemKey = null;
    this._hasToItemAmount = false;
    this._toItemAmount = null;
    this._hasRequiredGold = false;
    this._requiredGold = null;
  }
  isEmpty() {
    if (this._hasFromItemKey) return false;
    if (this._hasFromItemAmount) return false;
    if (this._hasToItemKey) return false;
    if (this._hasToItemAmount) return false;
    if (this._hasRequiredGold) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InventoryData_ItemConversionData) {
      return value;
    }
    return InventoryData_ItemConversionData.fromJson(value);
  }
  static fromJson(json) {
    const result = new InventoryData_ItemConversionData();
    if (json.fromItemKey != null) {
      result._hasFromItemKey = true;
      result._fromItemKey = JsonToString.fromJson(json.fromItemKey);
    }
    if (json.fromItemAmount != null) {
      result._hasFromItemAmount = true;
      result._fromItemAmount = JsonToInt32.fromJson(json.fromItemAmount);
    }
    if (json.toItemKey != null) {
      result._hasToItemKey = true;
      result._toItemKey = JsonToString.fromJson(json.toItemKey);
    }
    if (json.toItemAmount != null) {
      result._hasToItemAmount = true;
      result._toItemAmount = JsonToInt32.fromJson(json.toItemAmount);
    }
    if (json.requiredGold != null) {
      result._hasRequiredGold = true;
      result._requiredGold = JsonToInt32.fromJson(json.requiredGold);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasFromItemKey) {
      result.fromItemKey = JsonToString.toJson(this._fromItemKey);
    }
    if (this._hasFromItemAmount) {
      result.fromItemAmount = JsonToInt32.toJson(this._fromItemAmount);
    }
    if (this._hasToItemKey) {
      result.toItemKey = JsonToString.toJson(this._toItemKey);
    }
    if (this._hasToItemAmount) {
      result.toItemAmount = JsonToInt32.toJson(this._toItemAmount);
    }
    if (this._hasRequiredGold) {
      result.requiredGold = JsonToInt32.toJson(this._requiredGold);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get fromItemKey() {
    return this._hasFromItemKey ? this._fromItemKey : JsonToString.default;
  }
  get hasFromItemKey() {
    return this._hasFromItemKey;
  }
  setFromItemKey(path, value) {
    return {type: 'SET', path: path.concat(['fromItemKey']), value};
  }
  deleteFromItemKey(path) {
    return {type: 'DELETE', path: path.concat(['fromItemKey'])};
  }
  /**
   * @returns {number}
   */
  get fromItemAmount() {
    return this._hasFromItemAmount ? this._fromItemAmount : JsonToInt32.default;
  }
  get hasFromItemAmount() {
    return this._hasFromItemAmount;
  }
  setFromItemAmount(path, value) {
    return {type: 'SET', path: path.concat(['fromItemAmount']), value};
  }
  deleteFromItemAmount(path) {
    return {type: 'DELETE', path: path.concat(['fromItemAmount'])};
  }
  /**
   * @returns {string}
   */
  get toItemKey() {
    return this._hasToItemKey ? this._toItemKey : JsonToString.default;
  }
  get hasToItemKey() {
    return this._hasToItemKey;
  }
  setToItemKey(path, value) {
    return {type: 'SET', path: path.concat(['toItemKey']), value};
  }
  deleteToItemKey(path) {
    return {type: 'DELETE', path: path.concat(['toItemKey'])};
  }
  /**
   * @returns {number}
   */
  get toItemAmount() {
    return this._hasToItemAmount ? this._toItemAmount : JsonToInt32.default;
  }
  get hasToItemAmount() {
    return this._hasToItemAmount;
  }
  setToItemAmount(path, value) {
    return {type: 'SET', path: path.concat(['toItemAmount']), value};
  }
  deleteToItemAmount(path) {
    return {type: 'DELETE', path: path.concat(['toItemAmount'])};
  }
  /**
   * @returns {number}
   */
  get requiredGold() {
    return this._hasRequiredGold ? this._requiredGold : JsonToInt32.default;
  }
  get hasRequiredGold() {
    return this._hasRequiredGold;
  }
  setRequiredGold(path, value) {
    return {type: 'SET', path: path.concat(['requiredGold']), value};
  }
  deleteRequiredGold(path) {
    return {type: 'DELETE', path: path.concat(['requiredGold'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "fromItemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasFromItemKey = true;
              copy._fromItemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFromItemKey) {
                return this;
              }
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasFromItemKey = false;
              copy._fromItemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "fromItemAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasFromItemAmount = true;
              copy._fromItemAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFromItemAmount) {
                return this;
              }
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasFromItemAmount = false;
              copy._fromItemAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "toItemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasToItemKey = true;
              copy._toItemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasToItemKey) {
                return this;
              }
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasToItemKey = false;
              copy._toItemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "toItemAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasToItemAmount = true;
              copy._toItemAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasToItemAmount) {
                return this;
              }
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasToItemAmount = false;
              copy._toItemAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "requiredGold": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasRequiredGold = true;
              copy._requiredGold = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRequiredGold) {
                return this;
              }
              const copy = new InventoryData_ItemConversionData(this);
              copy._hasRequiredGold = false;
              copy._requiredGold = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InventoryData_ItemConversionData} other
   * @returns {InventoryData_ItemConversionData}
   */
  merge(other) {
    const copy = new InventoryData_ItemConversionData(this);
    if (other._hasFromItemKey) {
      copy._hasFromItemKey = true;
      copy._fromItemKey = other._fromItemKey;
    }
    if (other._hasFromItemAmount) {
      copy._hasFromItemAmount = true;
      copy._fromItemAmount = other._fromItemAmount;
    }
    if (other._hasToItemKey) {
      copy._hasToItemKey = true;
      copy._toItemKey = other._toItemKey;
    }
    if (other._hasToItemAmount) {
      copy._hasToItemAmount = true;
      copy._toItemAmount = other._toItemAmount;
    }
    if (other._hasRequiredGold) {
      copy._hasRequiredGold = true;
      copy._requiredGold = other._requiredGold;
    }
    return copy;
  }
}
InventoryData_ItemConversionData.default = new InventoryData_ItemConversionData();
class InventoryData_ItemConversionData_Builder {
  constructor(value) {
    this._value = new InventoryData_ItemConversionData(value);
  }
  build() {
    return new InventoryData_ItemConversionData(this._value);
  }
  setFromItemKey(value) {
    this._value._hasFromItemKey = true;
    this._value._fromItemKey = value;
    return this;
  }
  deleteFromItemKey() {
    this._value._hasFromItemKey = false;
    this._value._fromItemKey = null;
    return this;
  }
  setFromItemAmount(value) {
    this._value._hasFromItemAmount = true;
    this._value._fromItemAmount = value;
    return this;
  }
  deleteFromItemAmount() {
    this._value._hasFromItemAmount = false;
    this._value._fromItemAmount = null;
    return this;
  }
  setToItemKey(value) {
    this._value._hasToItemKey = true;
    this._value._toItemKey = value;
    return this;
  }
  deleteToItemKey() {
    this._value._hasToItemKey = false;
    this._value._toItemKey = null;
    return this;
  }
  setToItemAmount(value) {
    this._value._hasToItemAmount = true;
    this._value._toItemAmount = value;
    return this;
  }
  deleteToItemAmount() {
    this._value._hasToItemAmount = false;
    this._value._toItemAmount = null;
    return this;
  }
  setRequiredGold(value) {
    this._value._hasRequiredGold = true;
    this._value._requiredGold = value;
    return this;
  }
  deleteRequiredGold() {
    this._value._hasRequiredGold = false;
    this._value._requiredGold = null;
    return this;
  }
}
InventoryData_ItemConversionData.Builder = InventoryData_ItemConversionData_Builder;
class InventoryData_ItemConversionData_WithParent {
  /**
   * @param {InventoryData_ItemConversionData} value
   * @param {InventoryData_ItemConversionData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InventoryData_ItemConversionData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasFromItemKey() {
    if (this._cachedHasFromItemKey === undefined) {
      if (this._value.hasFromItemKey) {
        this._cachedHasFromItemKey = true;
      } else {
        this._cachedHasFromItemKey = this._parent ? this._parent.hasFromItemKey : false;
      }
    }
    return this._cachedHasFromItemKey;
  }
  get fromItemKey() {
    if (this._cachedFromItemKey === undefined) {
      if (this._value.hasFromItemKey) {
        this._cachedFromItemKey = this._value.fromItemKey;
      } else {
        this._cachedFromItemKey = this._parent ? this._parent.fromItemKey : this._value.fromItemKey;
      }
    }
    return this._cachedFromItemKey;
  }
  get hasFromItemAmount() {
    if (this._cachedHasFromItemAmount === undefined) {
      if (this._value.hasFromItemAmount) {
        this._cachedHasFromItemAmount = true;
      } else {
        this._cachedHasFromItemAmount = this._parent ? this._parent.hasFromItemAmount : false;
      }
    }
    return this._cachedHasFromItemAmount;
  }
  get fromItemAmount() {
    if (this._cachedFromItemAmount === undefined) {
      if (this._value.hasFromItemAmount) {
        this._cachedFromItemAmount = this._value.fromItemAmount;
      } else {
        this._cachedFromItemAmount = this._parent ? this._parent.fromItemAmount : this._value.fromItemAmount;
      }
    }
    return this._cachedFromItemAmount;
  }
  get hasToItemKey() {
    if (this._cachedHasToItemKey === undefined) {
      if (this._value.hasToItemKey) {
        this._cachedHasToItemKey = true;
      } else {
        this._cachedHasToItemKey = this._parent ? this._parent.hasToItemKey : false;
      }
    }
    return this._cachedHasToItemKey;
  }
  get toItemKey() {
    if (this._cachedToItemKey === undefined) {
      if (this._value.hasToItemKey) {
        this._cachedToItemKey = this._value.toItemKey;
      } else {
        this._cachedToItemKey = this._parent ? this._parent.toItemKey : this._value.toItemKey;
      }
    }
    return this._cachedToItemKey;
  }
  get hasToItemAmount() {
    if (this._cachedHasToItemAmount === undefined) {
      if (this._value.hasToItemAmount) {
        this._cachedHasToItemAmount = true;
      } else {
        this._cachedHasToItemAmount = this._parent ? this._parent.hasToItemAmount : false;
      }
    }
    return this._cachedHasToItemAmount;
  }
  get toItemAmount() {
    if (this._cachedToItemAmount === undefined) {
      if (this._value.hasToItemAmount) {
        this._cachedToItemAmount = this._value.toItemAmount;
      } else {
        this._cachedToItemAmount = this._parent ? this._parent.toItemAmount : this._value.toItemAmount;
      }
    }
    return this._cachedToItemAmount;
  }
  get hasRequiredGold() {
    if (this._cachedHasRequiredGold === undefined) {
      if (this._value.hasRequiredGold) {
        this._cachedHasRequiredGold = true;
      } else {
        this._cachedHasRequiredGold = this._parent ? this._parent.hasRequiredGold : false;
      }
    }
    return this._cachedHasRequiredGold;
  }
  get requiredGold() {
    if (this._cachedRequiredGold === undefined) {
      if (this._value.hasRequiredGold) {
        this._cachedRequiredGold = this._value.requiredGold;
      } else {
        this._cachedRequiredGold = this._parent ? this._parent.requiredGold : this._value.requiredGold;
      }
    }
    return this._cachedRequiredGold;
  }
  update(current, parent) {
    const result = new InventoryData_ItemConversionData_WithParent(current, parent);
    return result;
  }
}
InventoryData_ItemConversionData_WithParent.default = new InventoryData_ItemConversionData_WithParent(InventoryData_ItemConversionData.default, null);
InventoryData_ItemConversionData.WithParent = InventoryData_ItemConversionData_WithParent;
class InventoryData_ItemConversionData_Descriptor {
  get fromItemKey() {
    if (!this._fromItemKey) {
      this._fromItemKey = {
        name: "fromItemKey",
        Name: "FromItemKey",
        number: 1,
        protoType: 9,
        protoName: "from_item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fromItemKey;
  }
  get fromItemAmount() {
    if (!this._fromItemAmount) {
      this._fromItemAmount = {
        name: "fromItemAmount",
        Name: "FromItemAmount",
        number: 2,
        protoType: 5,
        protoName: "from_item_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fromItemAmount;
  }
  get toItemKey() {
    if (!this._toItemKey) {
      this._toItemKey = {
        name: "toItemKey",
        Name: "ToItemKey",
        number: 3,
        protoType: 9,
        protoName: "to_item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._toItemKey;
  }
  get toItemAmount() {
    if (!this._toItemAmount) {
      this._toItemAmount = {
        name: "toItemAmount",
        Name: "ToItemAmount",
        number: 4,
        protoType: 5,
        protoName: "to_item_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._toItemAmount;
  }
  get requiredGold() {
    if (!this._requiredGold) {
      this._requiredGold = {
        name: "requiredGold",
        Name: "RequiredGold",
        number: 5,
        protoType: 5,
        protoName: "required_gold",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._requiredGold;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.fromItemKey,
        this.fromItemAmount,
        this.toItemKey,
        this.toItemAmount,
        this.requiredGold,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForFromItemKey",
        Name: "DummyOneofForFromItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFromItemAmount",
        Name: "DummyOneofForFromItemAmount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForToItemKey",
        Name: "DummyOneofForToItemKey",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForToItemAmount",
        Name: "DummyOneofForToItemAmount",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRequiredGold",
        Name: "DummyOneofForRequiredGold",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
InventoryData_ItemConversionData.descriptor = new InventoryData_ItemConversionData_Descriptor();
export class InventoryData {
  get descriptor() {
    return InventoryData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._Items = [];
    this._itemConverstionData = [];
  }
  isEmpty() {
    if (this._Items.length > 0) return false;
    if (this._itemConverstionData.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InventoryData) {
      return value;
    }
    return InventoryData.fromJson(value);
  }
  static fromJson(json) {
    const result = new InventoryData();
    result._Items = JsonToList(json.Items, InventoryData_Item);
    result._itemConverstionData = JsonToList(json.itemConverstionData, InventoryData_ItemConversionData);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._Items.length > 0) {
      result.Items = ArrayToJson(this._Items, InventoryData_Item);
    }
    if (this._itemConverstionData.length > 0) {
      result.itemConverstionData = ArrayToJson(this._itemConverstionData, InventoryData_ItemConversionData);
    }
    return result;
  }
  /**
   * @returns {InventoryData_Item[]}
   */
  get Items() {
    return this._Items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['Items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['Items']), value: ArrayToJson(value, InventoryData_Item)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['Items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['Items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['Items', key])};
  }
  /**
   * @returns {InventoryData_ItemConversionData[]}
   */
  get itemConverstionData() {
    return this._itemConverstionData;
  }
  addItemConverstionData(path, value) {
    return {type: 'ADD', path: path.concat(['itemConverstionData']), value: value.toJson()};
  }
  setItemConverstionData(path, value) {
    return {type: 'SET', path: path.concat(['itemConverstionData']), value: ArrayToJson(value, InventoryData_ItemConversionData)};
  }
  setItemConverstionDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['itemConverstionData', key]), value: value.toJson()};
  }
  deleteItemConverstionData(path) {
    return {type: 'DELETE', path: path.concat(['itemConverstionData'])};
  }
  deleteItemConverstionDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['itemConverstionData', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "Items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData(this);
              copy._Items = [];        for (let i of value) {
                copy._Items.push(InventoryData_Item.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InventoryData(this);
              copy._Items = copy._Items.concat([InventoryData_Item.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._Items.length === 0) {
                return this;
              }
              const copy = new InventoryData(this);
              copy._Items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._Items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InventoryData(this);
              copy._Items = copy._Items.slice();
              copy._Items[path[1]] = InventoryData_Item.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InventoryData(this);
              copy._Items = copy._Items.slice(0, path[1]).concat(copy._Items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._Items.length) {
            return this;
          }
          const oldValue = this._Items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InventoryData(this);
          copy._Items = copy._Items.slice();
          copy._Items[key] = newValue;
          return copy;
        }
      }
      case "itemConverstionData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InventoryData(this);
              copy._itemConverstionData = [];        for (let i of value) {
                copy._itemConverstionData.push(InventoryData_ItemConversionData.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InventoryData(this);
              copy._itemConverstionData = copy._itemConverstionData.concat([InventoryData_ItemConversionData.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._itemConverstionData.length === 0) {
                return this;
              }
              const copy = new InventoryData(this);
              copy._itemConverstionData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._itemConverstionData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InventoryData(this);
              copy._itemConverstionData = copy._itemConverstionData.slice();
              copy._itemConverstionData[path[1]] = InventoryData_ItemConversionData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InventoryData(this);
              copy._itemConverstionData = copy._itemConverstionData.slice(0, path[1]).concat(copy._itemConverstionData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._itemConverstionData.length) {
            return this;
          }
          const oldValue = this._itemConverstionData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InventoryData(this);
          copy._itemConverstionData = copy._itemConverstionData.slice();
          copy._itemConverstionData[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InventoryData} other
   * @returns {InventoryData}
   */
  merge(other) {
    const copy = new InventoryData(this);
    copy._Items = this._Items.concat(other._Items);
    copy._itemConverstionData = this._itemConverstionData.concat(other._itemConverstionData);
    return copy;
  }
}
InventoryData.default = new InventoryData();
InventoryData.PurchaseGuide = InventoryData_PurchaseGuide;
InventoryData.Item = InventoryData_Item;
InventoryData.ItemConversionData = InventoryData_ItemConversionData;
class InventoryData_Builder {
  constructor(value) {
    this._value = new InventoryData(value);
  }
  build() {
    return new InventoryData(this._value);
  }
  addAllItems(values) {
    this._value._Items = this._value._Items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._Items = this._value._Items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._Items = this._value._Items.concat();
    this._value._Items[index] = value;
    return this;
  }
  clearItems() {
    this._value._Items = [];
    return this;
  }
  addAllItemConverstionData(values) {
    this._value._itemConverstionData = this._value._itemConverstionData.concat(values);
    return this;
  }
  addItemConverstionData(value) {
    this._value._itemConverstionData = this._value._itemConverstionData.concat([value]);
    return this;
  }
  setItemConverstionData(index, value) {
    this._value._itemConverstionData = this._value._itemConverstionData.concat();
    this._value._itemConverstionData[index] = value;
    return this;
  }
  clearItemConverstionData() {
    this._value._itemConverstionData = [];
    return this;
  }
}
InventoryData.Builder = InventoryData_Builder;
class InventoryData_WithParent {
  /**
   * @param {InventoryData} value
   * @param {InventoryData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InventoryData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.Items) {
        this._selfItems.push(new InventoryData_Item.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.Items : [];
    }
    return this._inherentItems;
  }
  get Items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.Items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get selfItemConverstionData() {
    if (!this._selfItemConverstionData) {
      this._selfItemConverstionData = [];
      for (let i of this._value.itemConverstionData) {
        this._selfItemConverstionData.push(new InventoryData_ItemConversionData.WithParent(i, null));
      }
    }
    return this._selfItemConverstionData;
  }
  get inherentItemConverstionData() {
    if (!this._inherentItemConverstionData) {
      this._inherentItemConverstionData = this._parent ? this._parent.itemConverstionData : [];
    }
    return this._inherentItemConverstionData;
  }
  get itemConverstionData() {
    if (!this._allItemConverstionData) {
      this._allItemConverstionData = this._parent ? this._parent.itemConverstionData.concat(this.selfItemConverstionData) : this.selfItemConverstionData;
    }
    return this._allItemConverstionData;
  }
  update(current, parent) {
    const result = new InventoryData_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.Items === current.Items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.Items.length; i++) {
          const oldValue = this._value.Items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.Items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.Items[i], null);
            }
          } else {
            result._selfItems[i] = new InventoryData_Item.WithParent(current.Items[i], null);
          }
        }
      }
    }
    if (this._selfItemConverstionData) {
      if (this._value.itemConverstionData === current.itemConverstionData) {
        result._selfItemConverstionData = this._selfItemConverstionData;
      } else {
        result._selfItemConverstionData = [];
        for (let i = 0; i < current.itemConverstionData.length; i++) {
          const oldValue = this._value.itemConverstionData[i];
          if (oldValue) {
            const oldCache = this._selfItemConverstionData[i];
            if (oldValue === current.itemConverstionData[i]) {
              result._selfItemConverstionData[i] = oldCache;
            } else {
              result._selfItemConverstionData[i] = oldCache.update(current.itemConverstionData[i], null);
            }
          } else {
            result._selfItemConverstionData[i] = new InventoryData_ItemConversionData.WithParent(current.itemConverstionData[i], null);
          }
        }
      }
    }
    return result;
  }
}
InventoryData_WithParent.default = new InventoryData_WithParent(InventoryData.default, null);
InventoryData.WithParent = InventoryData_WithParent;
class InventoryData_Descriptor {
  get Items() {
    if (!this._Items) {
      this._Items = {
        name: "Items",
        Name: "Items",
        number: 1,
        protoType: 11,
        protoName: "Items",
        type: InventoryData_Item,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Items;
  }
  get itemConverstionData() {
    if (!this._itemConverstionData) {
      this._itemConverstionData = {
        name: "itemConverstionData",
        Name: "ItemConverstionData",
        number: 2,
        protoType: 11,
        protoName: "item_converstion_data",
        type: InventoryData_ItemConversionData,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemConverstionData;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.Items,
        this.itemConverstionData,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
InventoryData.descriptor = new InventoryData_Descriptor();
